import {inlineError, streamify, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
@streamify('execute')
class UnsubscribeUserFavoriteUseCase extends UseCase {
  constructor({repository, unsubscribeUserFavoriteRequestFactory}) {
    super()
    this._repository = repository
    this._unsubscribeUserFavoriteRequestFactory = unsubscribeUserFavoriteRequestFactory
  }

  /**
   * @return {Promise<Object, Error>}
   */
  @tracer({metric: 'UnsubscribeUserFavoriteUseCase#execute'})
  @inlineError
  async execute({adId, token, userId}) {
    const unsubscribeFavoriteRequest = this._unsubscribeUserFavoriteRequestFactory({token, userId, adId})
    const [error, response] = await this._repository.unsubscribeFavorite({unsubscribeFavoriteRequest})

    if (error) throw error

    return response
  }
}

export default UnsubscribeUserFavoriteUseCase
